import { messaging } from './firebase-config';
import { getToken } from 'firebase/messaging';

export const requestForToken = async (): Promise<string | null> => {
  const permission = await Notification.requestPermission();

  if (permission !== 'granted') {
    console.warn('Notification permission not granted:', permission);
    return null;
  }

  try {
    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });

    if (currentToken) {
      console.log('FCM Token:', currentToken);
      return currentToken;
    } else {
      console.warn('No registration token available.');
      return null;
    }
  } catch (err) {
    console.error('An error occurred while retrieving token.', err);
    return null;
  }
};